import View from './View.js';

class AddRecipeView extends View {
  _message = `Recipe was succesfully uploaded...`;

  constructor(parentEl, overlay, addRecipeForm, btnClose, btnOpen) {
    super(parentEl);

    this._overlay = document.querySelector(overlay);
    this._addRecipeForm = this._parentEl.querySelector(addRecipeForm);
    this._btnClose = this._parentEl.querySelector(btnClose);
    this._btnOpen = document.querySelector(btnOpen);

    this._addHandlerShowModal();
    this._addHandlerCloseModal();
  }

  addHandlerUpload(handler) {
    this._addRecipeForm.addEventListener('submit', e => {
      e.preventDefault();

      const dataArray = [...new FormData(this._addRecipeForm)];
      const data = Object.fromEntries(dataArray);

      handler(data);
    });
  }

  _addHandlerShowModal() {
    this._btnOpen.addEventListener('click', this.toggleModal.bind(this));
  }
  _addHandlerCloseModal() {
    [this._btnClose, this._overlay].forEach(el =>
      el.addEventListener('click', this.toggleModal.bind(this))
    );
  }

  toggleModal() {
    this._overlay.classList.toggle('hidden');
    this._parentEl.classList.toggle('hidden');
  }
}

export default new AddRecipeView(
  '.add-recipe-window',
  '.overlay',
  '.upload',
  '.btn--close-modal',
  '.nav__btn--add-recipe'
);
